
import { getFirestore, collection, query, where, getDocs, doc, getDoc, setDoc, addDoc } from "firebase/firestore";
import nopic from '../components/img/nopic.jpg';
import { getStorage, ref as storageRef, getDownloadURL, uploadBytes } from 'firebase/storage';

/**
 * Get all events
 * @returns Array of events
 */
const getEvents = async () => {
    let eventsArray = [];
    const db = getFirestore();
    const q = query(collection(db, "events"), where('wasDeleted', '!=', true));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((champ) => {

        let localChamp = champ.data()
        localChamp.__key = champ.id

        /* Get date */
        let localDate = new Date(localChamp['data'])
        localChamp.dataToShow = localDate.getDate() + '/' + (localDate.getMonth() + 1) + '/' + localDate.getFullYear()

        /* Put no pic if champ hasn't img */
        if (localChamp.img === undefined)
            localChamp.img = nopic

        eventsArray.push(localChamp)
    });

    return eventsArray;
}

/**
 * Get an event
 * @param {String} eventId 
 * @returns An event
 */
const getEvent = async (eventId) => {
    const db = getFirestore();
    const docRef = doc(db, "events", eventId);
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) return null;
    return docSnap.data();
}

/**
 * Create a event
 * @param {Object} eventToCreate 
 * @param {File} eventAddObjectFile
 * @returns 
 */
const createEvent = async (eventToCreate, eventAddObjectFile) => {
    const db = getFirestore();
    const dbRef = collection(db, 'events')

    try {
        const event = await addDoc(dbRef, eventToCreate);
        const storage = getStorage();

        // Put file in firebase
        if (eventAddObjectFile) {
            const imageRef = storageRef(storage, 'eventsPhotos/' + event.id);

            await uploadBytes(imageRef, eventAddObjectFile, { contentType: 'image/jpeg' });

            const fileUrl = await getDownloadURL(imageRef);

            const dbRefToUpdateFile = doc(db, 'events', event.id);
            await setDoc(dbRefToUpdateFile, { img: fileUrl }, { merge: true });
        }

        return {
            message: 'Evento criado com sucesso',
        }
    } catch (err) {
        return {
            error: true,
            message: err.message,
        }
    }
}

/**
 * Update a event
 * @param {String} eventId 
 * @param {Object} eventToUpdate 
 * @param {File} eventAddObjectFile
 * @returns 
 */
const updateEvent = async (eventId, eventToUpdate, eventAddObjectFile) => {
    const db = getFirestore();
    const dbRef = doc(db, 'events', eventId)

    try {
        await setDoc(dbRef, eventToUpdate, { merge: true });
        const storage = getStorage();

        // Put file in firebase
        if (eventAddObjectFile) {
            const imageRef = storageRef(storage, 'eventsPhotos/' + eventId);

            await uploadBytes(imageRef, eventAddObjectFile, { contentType: 'image/jpeg' });

            const fileUrl = await getDownloadURL(imageRef);

            const dbRefToUpdateFile = doc(db, 'champs', eventId);
            await setDoc(dbRefToUpdateFile, { img: fileUrl }, { merge: true });
        }

        return {
            message: 'Evento atualizado com sucesso',
        }
    } catch (err) {
        return {
            error: true,
            message: err.message,
        }
    }
}

/**
 * Delete a event
 * @param {String} eventId 
 * @returns null
 */
const deleteAEvent = async (eventId) => {
    try {
        const db = getFirestore();
        const dbRef = doc(db, 'events', eventId);
        await setDoc(dbRef, { wasDeleted: true }, { merge: true });
        return true;
    } catch (e) {
        return false;
    }
}

export {
    getEvents,
    getEvent,
    createEvent,
    updateEvent,
    deleteAEvent,
}